import React, { useState } from "react"
import { Field } from "formik"
import PropTypes from "prop-types"

export const InputCustom = ({
  formik,
  id,
  name,
  variant,
  theme,
  as,
  type,
  label,
  placeholder,
  value,
  formText,
  onChange,
  onBlur,
  errors,
  touched,
  iconRight,
  iconLeft,
  floatingLabel,
  className,
  wrapperClassName,
  labelClassName,
  inputClassName,
  children,
  disabled,
  hideValidationText,
  rows,
  onKeyPress,
}) => {
  const [searchInput, setSearchInput] = useState('')
  const fieldVariant = () => {
    if (variant === "underline") {
      return "field-underline"
    } else {
      return "field-basic"
    }
  }

  return (
    <div
      className={`field ${fieldVariant()} 
        ${theme} 
        ${floatingLabel ? "field-floating" : ""} 
        ${touched && errors && touched[name] && errors[name] ? "is-invalid" : ""
        }
        ${className} `}
    >
      {label && (
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
      )}

      {as === "input" && (
        <div
          className={`form-control-wrapper
          ${iconRight ? "ic-right" : ""}
          ${iconLeft ? "ic-left" : ""}
          ${wrapperClassName}`}
        >
          <div className="d-flex justify-content-between align-items-center">
            <input
              id={id}
              name={name}
              type={type}
              placeholder={placeholder}
              className={`form-control ${inputClassName}`}
              value={value || searchInput}
              onBlur={onBlur}
              onChange={e => {
                onChange(e)
                setSearchInput(e.target.value)
              }}
              disabled={disabled}
              onKeyPress={onKeyPress}
            />
            {searchInput ?
              <i className="ail ai-times" onClick={() => setSearchInput('')} />
              :
              <i className="ail ai-search" />
            }
          </div>
          {floatingLabel && (
            <label className={labelClassName} htmlFor={id}>
              {label}
            </label>
          )}
          <i className="el-underline" />
          {children}
        </div>
      )}

      {as === "textarea" && (
        <div
          className={`form-control-wrapper
          ${iconRight ? "ic-right" : ""}
          ${iconLeft ? "ic-left" : ""}
          ${wrapperClassName}`}
        >
          {formik ? (
            <Field
              id={id}
              placeholder={placeholder}
              name={name}
              className={`form-control ${inputClassName}`}
              disabled={disabled}
              as="textarea"
              rows={rows}
              value={value}
              onBlur={onBlur}
              onChange={onChange}
            />
          ) : (
            <textarea
              id={id}
              name={name}
              placeholder={placeholder}
              className={`form-control ${inputClassName}`}
              value={value}
              onBlur={onBlur}
              onChange={onChange}
              disabled={disabled}
              rows={rows}
            />
          )}

          {floatingLabel && (
            <label className={labelClassName} htmlFor={id}>
              {label}
            </label>
          )}
          <i className="el-underline" />
          {children}
        </div>
      )}

      {as === "select" && (
        <div
          className={`form-select-wrapper
          ${iconRight ? "ic-right" : ""}
          ${iconLeft ? "ic-left" : ""}
          ${wrapperClassName}`}
        >
          {floatingLabel && (
            <label className={labelClassName} htmlFor={id}>
              {label}
            </label>
          )}
          {formik ? (
            <Field
              id={id}
              placeholder={placeholder}
              name={name}
              className={`form-control ${inputClassName}`}
              disabled={disabled}
              as="select"
              value={value}
              onBlur={onBlur}
              onChange={onChange}
            >
              {children}
            </Field>
          ) : (
            <select
              id={id}
              name={name}
              className={`form-control ${inputClassName}`}
              disabled={disabled}
              value={value}
              onBlur={onBlur}
              onChange={onChange}
            >
              {children}
            </select>
          )}
          <i className="el-underline" />
        </div>
      )}

      {!hideValidationText && (
        <>
          {touched && errors && touched[name] && errors[name] && (
            <div className="invalid-feedback">{errors[name]}</div>
          )}
        </>
      )}
      {formText && <div className="form-text">{formText}</div>}
    </div>
  )
}

InputCustom.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  variant: PropTypes.oneOf(["basic", "underline"]),
  theme: PropTypes.oneOf(["light", "dark"]),
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  as: PropTypes.string,
  value: PropTypes.string,
  floatingLabel: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  children: PropTypes.any,
}

InputCustom.defaultProps = {
  id: "",
  type: "text",
  variant: "basic",
  theme: "light",
  label: null,
  as: "input",
  placeholder: "Enter text",
  className: "",
  labelClassName: "",
  inputClassName: "",
  wrapperClassName: "",
  hideValidationText: false,
}
